import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";



export default function AutenticaCartao({
  autenticaCartao
}: {
    autenticaCartao: any
}) {
  const { t } = useTranslation();
  const headerCard= () => {
    return <div className="flex-score align-items-center" style={{padding: '1.5rem'}}><div className="flex-score justify-content-center align-items-center p-2 border-round" style={{backgroundColor: '#cc7a00'}}><i className="pi pi-comment" style={{color: "#FFF"}}></i></div><span className="text-xl ml-2 font-semibold">Motivo</span></div>
  } 
  return (
    <Panel header={t('autenticaCartao')}>
        { autenticaCartao.map((motivo:string) => {
            return (
            <>
                <Card className="flex-score flex-column" header={headerCard()} style={{color: '#cc7a00', borderLeft: '4px solid', background:'rgb(248,248,255)'}}>
                    <div className="grid">
                        <div className="col-9 flex-score flex-column text-center  surface-border">
                        
                            <span className="text-color font-semibold">{motivo}</span>
                        </div>
                
                    </div>
                </Card>
                <br></br>
            </>
            )
        }) }
       
    </Panel>
  )}